import React from 'react';
import { Alert, Typography } from 'antd';

const { Text } = Typography;

const msgTypes = {
  all: 'all',
  owner: 'owner',
  worker: 'worker',
  cityServices: 'cityServices',
};

const alertTypes = {
  alert: 'alert',
  text: 'text',
};

const messages = {
  [msgTypes.all]:
    'После сохранения изменений отправится новое уведомление всем, кто указан в настройках уведомлений',
  [msgTypes.owner]:
    'Если в настройках уведомлений указаны собственники, то после сохранения изменений им отправится новое уведомление',
  [msgTypes.worker]:
    'Если в настройках уведомлений указаны сотрудники, то после сохранения изменений им отправится новое уведомление ',
  [msgTypes.cityServices]:
    'Если в настройках уведомлений указаны городские службы, то после сохранения изменений им отправится новое уведомление ',
};

const AlertComponent = ({ message }) => {
  return (
    <Alert
      message={message}
      type="info"
      showIcon
    />
  );
};

const TextComponent = ({ message }) => {
  return <Text>{message}</Text>;
};

const renderContent = ({ alertType, ...props }) => {
  switch (alertType) {
    case alertTypes.alert:
      return <AlertComponent {...props} />;

    case alertTypes.text:
      return <TextComponent {...props} />;

    default:
      return null;
  }
};

const NotificationSendingAlert = ({
  alertType = alertTypes.alert,
  messageType,
}) => {
  const message = messages[messageType || ''];
  return !message ? null : renderContent({ alertType, message });
};

export default NotificationSendingAlert;
export {
  msgTypes as notificationSendingAlertMsgTypes,
  alertTypes as notificationSendingAlertTypes,
};
